/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./../../../js/bootstrap');
require('jquery-validation/dist/jquery.validate');
require('jquery-validation/dist/additional-methods');
require('jquery-validation/dist/localization/messages_ja');
require('jcarousel/dist/jquery.jcarousel');
require('./_jcarousel');
require('./_list-group-collapse');
require('./_footer');
require('bootstrap-notify/bootstrap-notify');
